import CategoriaFiltro from "./categoriaFiltro.component";

const CardFiltro = (props) => {
    const { numfiltrados, item, history, filtros, setMostrarFiltro, totalRegistros, filtrosSeleccionados, setFiltrosSeleccionados } = props;
    const llaves = Object.keys(filtros);

    const buscarFiltro = (id) => {
        const obtenido = filtrosSeleccionados.find(fs => fs.id == id);
        return obtenido ? true : false;
    }

    const handlefilterCancel = (e, id) => {
        if (buscarFiltro(id)) {
            //En caso de que ya haya estado como filtro
            const aux = filtrosSeleccionados.filter((fs) => fs.id != id)
            setFiltrosSeleccionados(aux)
            if (aux.length == 0) {
                if (item == "Marcas") {
                    history.push("./Catalogo/Categoria/-1/Todos/1")
                }
            }
        }
    }


    return (
        <div className="contenedor" >
            <div className="contenedor-acciones">
                <p><i className="fa fa-sliders" aria-hidden="true"></i>Filtros</p>
                <div
                    className="contenedor-acciones-item"
                    onClick={
                        () => {
                            setMostrarFiltro(f => !f);
                        }
                    }
                >
                    Cerrar filtro
                    <div className="icono-caret">
                        <i className="fa fa-caret-left" aria-hidden="true"></i>
                    </div>
                </div>
            </div>

            <hr />

            <div className="contenedor-filtro">
                <div className="contenedor-filtro-contador">
                    <p>Filtrando <span>{numfiltrados} productos</span> de {totalRegistros}</p>
                    <div className="contenedor-filtro-contador-filtros">

                        {
                            filtrosSeleccionados.map(
                                (fs, i) => {
                                    return (
                                        <div key={i + "" + fs.nombre} className="contenedor-filtro-contador-filtros-item">
                                            {fs.nombre}
                                            <div
                                                className="circulo"
                                                onClick={
                                                    (e) => {
                                                        handlefilterCancel(e, fs.id);
                                                    }
                                                }
                                            >
                                                <i className="fa fa-times" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    )
                                }
                            )
                        }

                    </div>
                </div>
            </div>

            <hr />

            {
                llaves.map(
                    (f, i) => {
                        return (
                            <>
                                <CategoriaFiltro
                                    history={history}
                                    opcion={item}
                                    claseIcono={"fa fa-caret-up"}
                                    tipo={f}
                                    filtros={filtros[f]}
                                    filtrosSeleccionados={filtrosSeleccionados}
                                    setFiltrosSeleccionados={setFiltrosSeleccionados}
                                />
                                <hr />
                            </>
                        )
                    }
                )
            }
            {/* <CategoriaFiltro titulo={"Sabor"} claseIcono={"fa fa-caret-up"} filtros={[]} /> */}
        </div>
    )
}

export default CardFiltro;
